import { WindowProxy } from '@sm360/widget-commons-core-services';

/* eslint-disable no-underscore-dangle */
class ShiftDigitalService {
    hasShiftDigital() {
        return !!(WindowProxy.get() && WindowProxy.get().sd);
    }

    createFormEvent(leadId, formType) {
        if (this.hasShiftDigital()) {
            WindowProxy.get().sd('dataLayer', {
                leadId,
                formType,
                events: 'formSubmission',
            });
            WindowProxy.get().sd('send');
        }
    }

    updateListingEvent(criteria, metadata, vehicleCount) {
        let currentStatus = 'DEFAULT';
        let minYear = 'ALL';
        let maxYear = 'ALL';
        let bodyStyle = 'ALL';
        let make = 'ALL';
        let model = 'ALL';

        if (this.hasShiftDigital()) {
            if (criteria._map && criteria._map._root && criteria._map._root.entries) {
                criteria._map._root.entries.forEach((entry) => {
                    const currentColander = entry[0];
                    const currentValue = entry[1];
                    if (currentColander === 'colanderSlug') {
                        currentStatus = currentValue.toUpperCase();
                    }
                    if (currentColander === 'yearRange' && currentValue && currentValue.type) {
                        minYear = currentValue.from;
                        maxYear = currentValue.to;
                    }
                    if (currentColander === 'frameStyleTypes' && currentValue && currentValue.length > 0) {
                        bodyStyle = currentValue.join();
                    }
                    if (currentColander === 'makeIds') {
                        make = this.getCurrentMeta(currentColander, currentValue, metadata, 'makeIds', 'MAKE');
                    }
                    if (currentColander === 'modelIds') {
                        model = this.getCurrentMeta(currentColander, currentValue, metadata, 'modelIds', 'MODEL');
                    }
                });

                WindowProxy.get().sd('dataLayer', {
                    countSearchResults: vehicleCount,
                    filterSearch: {
                        status: currentStatus,
                        minYear,
                        maxYear,
                        make,
                        model,
                        minPrice: 'ALL',
                        maxPrice: 'ALL',
                        bodyStyle,
                    },
                    events: 'filterSearch',
                });
                WindowProxy.get().sd('send');
            }
        }
    }

    updateCatalogEvent(filters) {
        let bodyStyle = 'ALL';
        let make = 'ALL';
        let searchBar = '';

        if (this.hasShiftDigital()) {
            if (filters._map && filters._map._root && filters._map._root.entries) {
                filters._map._root.entries.forEach((entry) => {
                    const currentColander = entry[0];
                    const currentValue = entry[1];
                    if (currentColander === 'preferredMake') {
                        make = currentValue;
                    }
                    if (currentColander === 'modelSearchString') {
                        searchBar = currentValue;
                    }
                    if (currentColander === 'bodyStylesFilterCodes' && currentValue && currentValue.length > 0) {
                        bodyStyle = Array.isArray(currentValue) ? currentValue.join() : currentValue;
                    }
                });

                WindowProxy.get().sd('dataLayer', {
                    typedSearch: {
                        typedSearchContent: searchBar,
                    },
                    events: 'typedSearch',
                });

                WindowProxy.get().sd('dataLayer', {
                    filterSearch: {
                        make,
                        bodyStyle,
                    },
                    events: 'filterSearch',
                });
                WindowProxy.get().sd('send');
            }
        }
    }

    getCurrentMeta(currentColander, currentValue, metadata, colander, metaName) {
        let value = 'ALL';
        if (currentColander === colander && currentValue && currentValue.length > 0) {
            metadata.filter((meta) => meta.name === metaName).some((meta) => {
                const metadatas = meta.metadatas.filter((data) => data._map._root.entries[0][1] === currentValue[0]);
                if (metadatas) {
                    value = metadatas[0].label;
                    return true;
                }
                return false;
            });
        }
        return value;
    }
}

export default new ShiftDigitalService();



// WEBPACK FOOTER //
// ./src/services/ShiftDigitalService/ShiftDigitalService.js